module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.albums_tab),
      callback: function($$v) {
        _vm.albums_tab = $$v
      },
      expression: "albums_tab"
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.albums_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.albums_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-tabs-content', {
    key: "published",
    attrs: {
      "id": "published"
    }
  }, [(_vm.albums_tab == 'published') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "album-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.album_headers,
      "items": _vm.published_albums,
      "pagination": _vm.published_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_published_albums
    },
    on: {
      "update:pagination": function($event) {
        _vm.published_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name))])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.username))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.played))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.downloaded))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1), _vm._v(" "), (!props.item.recommended) ? _c('v-list-tile', {
          key: "recommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.recommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Recommend")])])], 1) : _vm._e(), _vm._v(" "), (props.item.recommended) ? _c('v-list-tile', {
          key: "unrecommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.unrecommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Unrecommend")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_published_albums) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "privated",
    attrs: {
      "id": "privated"
    }
  }, [(_vm.albums_tab == 'privated') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "album-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.album_headers,
      "items": _vm.privated_albums,
      "pagination": _vm.privated_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_privated_albums
    },
    on: {
      "update:pagination": function($event) {
        _vm.privated_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name) + " sdas")])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.username))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.played))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.downloaded))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1), _vm._v(" "), (!props.item.recommended) ? _c('v-list-tile', {
          key: "recommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.recommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Recommend")])])], 1) : _vm._e(), _vm._v(" "), (props.item.recommended) ? _c('v-list-tile', {
          key: "unrecommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.unrecommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Unrecommend")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_privated_albums) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "product",
    attrs: {
      "id": "product"
    }
  }, [(_vm.albums_tab == 'product') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "product-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.product_headers,
      "items": _vm.products,
      "pagination": _vm.product_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_products
    },
    on: {
      "update:pagination": function($event) {
        _vm.product_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.covers[0].cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name))])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                " + _vm._s(props.item.merchant.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.sold))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (!props.item.recommended) ? _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openProductDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openProductDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_products) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.show_album_detail_dialog) ? _c('album-detail-dialog', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.closeAlbumDetailDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_product_detail_dialog) ? _c('product-detail-dialog', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeProductDetailDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_album_delete_confirm_modal),
      callback: function($$v) {
        _vm.show_album_delete_confirm_modal = $$v
      },
      expression: "show_album_delete_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Delete Album\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will no longer be available to users.\n        Click OK to delete <" + _vm._s(_vm.album.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_product_delete_confirm_modal),
      callback: function($$v) {
        _vm.show_product_delete_confirm_modal = $$v
      },
      expression: "show_product_delete_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Delete Product\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the product will no longer be available to users.\n        Click OK to delete <" + _vm._s(_vm.product.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProduct()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa8ff3c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/albums.vue
// module id = 1645
// module chunks = 180